export default __webpack_public_path__ + "static/media/cage-spiral.031d55cb.svg";